import React from "react";
import { Link } from "react-router-dom";
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

import {
  FaTelegram,
  FaInstagram
} from "react-icons/fa";
import logo from "../assets/image/logo-1.png"; // <-- LOGO IMAGE

const socialLinks = [
  {
    icon: <FaTelegram />,
    url: "https://t.me/trinitymanagementservices",
  },
  {
    icon: <FaInstagram />,
    url: "https://www.instagram.com/trinitymanagementservices.ca/?igsh=MTlvdXppZ2txOXNjbQ%3D%3D",
  },
  {
    icon: <FaWhatsapp />,
    url: "https://wa.me/message/DUQL24HZRZGOC1",
  },

];

// const immigrationLinks = [
//   { name: "Take IELTS" },
//   { name: "PTE Coaching" },
//   { name: "SAT Coaching" },
//   { name: "Student " },
//   { name: "Immigration " },
//   { name: "Diploma " },
// ];

const quickLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about-us" },
  { name: "Service", path: "/services" },
  { name: "Contact Us", path: "/contact-us" },
  // { name: "Login", path: "/" },
];

const Footer = () => {
  return (
    <footer className="bg-[#0C2136] text-white pt-10 md:pt-20">
      <div className="max-w-7xl mx-auto px-4">

        {/* TOP FOOTER */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 md:gap-12 pb-8 md:pb-16">
          {/* ABOUT */}
          <div>
            <img src={logo} alt="Trinity Logo" className="mb-5 w-40" />

            <p className="text-[#fff]text-[15px] leading-relaxed mb-6">
              Trinity Management Services provides administrative and coordination support for individuals navigating immigration processes.
            </p>

            <div className="flex gap-4 text-lg">
              {socialLinks.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-red-500 transition"
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* IMMIGRATION */}
          {/* <div>
            <h4 className="text-xl font-semibold mb-6">Immigration</h4>
            <ul className="space-y-3 text-[#fff]">
              {immigrationLinks.map((item, index) => (
                <li key={index}>
                  <Link to={item.path} className="hover:text-red-500 flex items-center gap-2">
                    <FaLongArrowAltRight className="text-[#7b8a9a]" /> {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          {/* QUICK LINKS */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3 text-[#fff]">
              {quickLinks.map((item, index) => (
                <li key={index}>
                  <Link to={item.path} className="hover:text-red-500 flex items-center gap-2">
                    <FaLongArrowAltRight className="text-[#7b8a9a]" /> {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* BOTTOM FOOTER */}
        <div className="border-t border-white/10 py-6 flex flex-col md:flex-row justify-between items-center text-sm text-[#fff]">
          <p>
            © {new Date().getFullYear()} TRINITY Immigration & Firm. All rights reserved.
          </p>

          <div className="flex gap-4 mt-4 md:mt-0">
            <Link to="/" className="hover:text-red-500">Home</Link>
            <span>|</span>
            <Link to="/about-us" className="hover:text-red-500">About Us</Link>
            <span>|</span>
            <Link to="/contact-us" className="hover:text-red-500">Contact Us</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
